import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getTrackBackground, Range } from "react-range";

export function FinanceRange({ placeHolder, min, max, step, suffix, firstValue, onChangeValue }) {
    const { i18n } = useTranslation();
    let lang = (i18n.language || 'ar');
    const [values, setValues] = useState([firstValue]);
    const RTL = lang === "ar";

    useEffect(() => {
        setValues([firstValue]);
    }, [firstValue]);

    const handleChangeValueRange = (newValues) => {
        setValues(newValues);
        if (onChangeValue) {
            onChangeValue(newValues);
        }
    };

    return (
        <div className="calc-grp" style={{ width: '100%', padding: '0 5px' }}>
            <label style={{ fontSize: '11px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px', color: '#94a3b8', marginBottom: '8px', display: 'block' }}>{placeHolder}</label>
            <div className="cv" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <span style={{ fontSize: '18px', fontWeight: '900', color: '#111827' }}>{values[0]?.toLocaleString()}</span>
                <span style={{ fontSize: '12px', fontWeight: '700', color: '#64748b' }}>{suffix}</span>
            </div>
            <div className="calc-range-wrapper" style={{ padding: '8px 0 20px 0', width: '100%' }}>
                <Range
                    values={values}
                    step={step}
                    min={min}
                    max={max}
                    rtl={RTL}
                    onChange={handleChangeValueRange}
                    renderTrack={({ props, children }) => (
                        <div
                            onMouseDown={props.onMouseDown}
                            onTouchStart={props.onTouchStart}
                            style={{
                                ...props.style,
                                height: "30px",
                                display: "flex",
                                width: "100%"
                            }}
                        >
                            <div
                                ref={props.ref}
                                style={{
                                    height: "6px",
                                    width: "100%",
                                    borderRadius: "10px",
                                    background: getTrackBackground({
                                        values: values,
                                        colors: ["var(--g)", "#f1f5f9"],
                                        min: min,
                                        max: max,
                                        rtl: RTL
                                    }),
                                    alignSelf: "center"
                                }}
                            >
                                {children}
                            </div>
                        </div>
                    )}
                    renderThumb={({ props, isDragged }) => (
                        <div
                            {...props}
                            style={{
                                ...props.style,
                                height: "24px",
                                width: "24px",
                                borderRadius: "50%",
                                backgroundColor: "#fff",
                                boxShadow: isDragged ? "0 0 15px rgba(24, 169, 78, 0.4)" : "0 4px 10px rgba(0, 0, 0, 0.1)",
                                border: "3px solid var(--g)",
                                outline: "none",
                                cursor: "pointer",
                                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                                transform: isDragged ? props.style.transform + ' scale(1.1)' : props.style.transform
                            }}
                        />
                    )}
                />
            </div>
        </div>
    );
}
